module.exports = __webpack_public_path__ + "img/add.915bb1ce.svg";